import { Injectable } from '@angular/core';
import { BaseDAO } from './baseDAO';
import { ConstantMan } from '../constantMan';
import { ApiHelper } from '../apiHelper';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { CharterAlternateTimeRequest } from '../../charterAlternateTimeRequest';

@Injectable()
export class CharterAlternateTimeRequestsDAO extends BaseDAO<CharterAlternateTimeRequest> {
  constructor(public readonly apiHelper: ApiHelper) {
    super(apiHelper, ConstantMan.API.RESOURCE.CHARTER_ALTERNATE_TIME_REQUESTS);
  }

  getCharterAlternateResponseStatusByCharterId(
    charterId: number,
    vesselId: number,
  ): Observable<Partial<CharterAlternateTimeRequest>> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/response-status/charter/' +
      charterId +
      '/vessel/' +
      vesselId;
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();

    return this.apiHelper.apiCall<CharterAlternateTimeRequest>(
      url,
      method,
      null,
      null,
      headers,
    );
  }

  getAllCharterAlternateTimes(
    charterId: number,
    vesselId: number,
  ): Observable<Partial<CharterAlternateTimeRequest>> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/charter/' +
      charterId +
      '/vessel/' +
      vesselId;
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();

    return this.apiHelper.apiCall<CharterAlternateTimeRequest>(
      url,
      method,
      null,
      null,
      headers,
    );
  }

  updateCharterTimeRequest(
    charterId: number,
    vesselId: number,
    alternateTimeRequest: Partial<CharterAlternateTimeRequest>,
    charterDuration: number,
  ): Observable<boolean> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/update-time-request/' +
      charterId +
      '/vessel/' +
      vesselId;
    const method = 'PUT';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    const data = {
      alternateTimeRequest: alternateTimeRequest,
      charterDuration: charterDuration,
    };

    return this.apiHelper.apiCall<boolean>(url, method, null, data, headers);
  }

  cancelCharterTimeRequest(
    charterId: number,
    vesselId: number,
  ): Observable<CharterAlternateTimeRequest> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/cancel/' +
      charterId +
      '/vessel/' +
      vesselId;
    const method = 'PUT';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<CharterAlternateTimeRequest>(
      url,
      method,
      null,
      null,
      headers,
    );
  }

  sendAlternateTimes(
    charterId: number,
    charterDate: string,
    alternateTimes: string[],
    boatOwnerPublicId: string,
  ): Observable<boolean> {
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      `/create-alternate-times-request/${charterId}/${boatOwnerPublicId}`;
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    const data = {
      charterDate: charterDate,
      charterId: charterId,
      alternateTimes: alternateTimes,
    };
    return this.apiHelper.apiCall<boolean>(url, method, null, data, headers);
  }
}
